module.exports = "<div>\n    <re-captcha language=\"langue\" site_key=\"6LeApTYUAAAAAAHti5JqSDXQt2Stv6NppqxFnTZK\"\n                (captchaResponse)=\"captchaResponse($event)\"\n                (captchaExpired)=\"captchaExpiration($event)\"></re-captcha>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/asi-captcha/asi-captcha.component.html
// module id = ../../../../../../../../../../digicerba-common-module/src/components/asi-captcha/asi-captcha.component.html
// module chunks = 0